// src/pages/Register.js
import { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  async function handleRegister(e) {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      // Just create Firebase Auth user - that's it!
      // The Cloud Function will automatically send verification email
      // User document will be created AFTER they verify
      await createUserWithEmailAndPassword(auth, email, password);

      // Store name temporarily in localStorage for later
      localStorage.setItem("pendingUserName", name);

      // Redirect to verification page
      navigate("/verify-email", {
        replace: true,
        state: { email, name }
      });

    } catch (err) {
      console.error("Registration error:", err.message);

      if (err.code === "auth/email-already-in-use") {
        setErrorMsg("This email is already registered.");
      } else if (err.code === "auth/weak-password") {
        setErrorMsg("Password must be at least 6 characters.");
      } else {
        setErrorMsg("Unable to create account. Try again.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-overlay"></div>

      <div className="login-container">
        <h2>Create Account</h2>

        <form onSubmit={handleRegister} className="login-form">
          <input
            type="text"
            placeholder="Full name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Create password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button className="login-btn" disabled={loading}>
            {loading ? "Creating account…" : "Register"}
          </button>

          {errorMsg && <p className="login-error">{errorMsg}</p>}
        </form>

        <Link to="/login" className="login-register-link">
          Already have an account? Sign in
        </Link>
      </div>
    </div>
  );
}